import styles from "../ExpeditionDetails/ExpeditionDetails.module.css";
import { Prize } from "../../types";
import { Reward } from "../../../../Components/Reward/Reward";

interface ExpeditionPrizesProps {
	prizes: Prize[];
}

const ExpeditionPrizes: React.FC<ExpeditionPrizesProps> = ({ prizes }) => {
	const formatType = (currency: "CHARACTER" | "TICKET" | "USDT" | "DC") => {
		switch (currency) {
			case "CHARACTER":
				return "character";
			case "TICKET":
				return "ticket";
			case "USDT":
				return "USDT";
			case "DC":
				return "dc";
		}
	};

	return (
		<div className={styles.prizesContainer}>
			<div className={styles.infoContainer}>
				<div className={styles.chanceText}>
					<p className={styles.chanceTopInfo}>Возможные награды</p>
				</div>

				<div className={styles.placesContainer}>
					{prizes?.map(prize => (
						<div className={styles.place}>
							<div className={`${styles.placePrize}`}>
								<Reward
									type={formatType(prize.currency)}
									amount={prize.amount}
									characterType={
										prize.currency === "CHARACTER"
											? (prize.details.type.toLowerCase() as
													| "legendary"
													| "epic")
											: undefined
									}
								/>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export { ExpeditionPrizes };
